// extracted by mini-css-extract-plugin
module.exports = {"hide":"tooltip_hide__xc2wz","show":"tooltip_show__50FS3"};